import { Link } from 'react-router-dom';

import styled, { css } from 'styled-components';

import colors from '../../../../../theme/colors';
import media from '../../../../../theme/media';

const getBoxShadow = (props) => {
    const raised = props.raised && props.raised.toString() === 'true';
    return raised ? `0 0 1px ${colors.codGray12}, 0 0 8px ${colors.codGray04}, 0 8px 8px ${colors.codGray04}` : 'none';
};

const CommonCss = css`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => (props.variant === 'secondary_filled' ? colors.purpleRgba08 : colors.white)};
    border: none;
    border-radius: 50%;
    width: ${(props) => (props.size === 'small' ? '28px' : '40px')};
    height: ${(props) => (props.size === 'small' ? '28px' : '40px')};
    padding: 0;
    box-shadow: ${(props) => getBoxShadow(props)};
    pointer-events: auto;
    cursor: pointer;
    margin-right: ${(props) => (props.$marginRight ? props.$marginRight : null)};

    &:hover {
        background-color: ${(props) => (props.variant === 'secondary_filled' ? colors.purpleRgba16 : 'transparent')};
    }

    @media (hover: hover) {
        &:hover,
        &:active {
            background-color: ${(props) => (props.variant === 'secondary_filled' ? colors.purpleRgba16 : colors.superLightGray)};
        }
    }

    &:focus {
        background-color: ${(props) => (props.variant === 'secondary_filled' ? colors.purpleRgba16 : colors.white)};
    }

    &:focus-visible {
        outline: 1px dashed ${colors.superLightPurple};
    }

    ${media.desktop1920} {
        width: ${(props) => (props.size === 'small' ? '32px' : '56px')};
        height: ${(props) => (props.size === 'small' ? '32px' : '56px')};
    }
`;

export const CommonButton = styled.button`
    ${CommonCss};
`;
export const LinkButton = styled.a`
    ${CommonCss};
`;
export const ReactLinkButton = styled(Link)`
    ${CommonCss};
`;
